const policyReinstatementStatus = {
    INVALID : 0,

    REINSTATED : 1

};

angular.module('gw-um-j2js')
    .constant('policyReinstatementStatus', policyReinstatementStatus);